import code from '../../../lib/appfuse-react/core/code';
import { activityOptions } from '../../Resume/constants';

/**
 * Truncate text to specified length
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length (default 10)
 * @returns {string} Truncated text with ellipsis if needed
 */
export const truncateText = (text, maxLength = 10) => {
  if (!text) return text;
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

// Maximum number of campaign chips to display before showing "+N more"
export const MAX_VISIBLE_CHIPS = 2;

/**
 * Translate campaign code to display name
 * Uses backend code table first, falls back to activityOptions from Resume
 * @param {string} campaignCode - Campaign code (e.g., 'ntu2026')
 * @returns {string} Translated campaign name
 */
export const translateCampaign = (campaignCode) => {
  if (!campaignCode) return '未指定場次';

  // Try backend code table first
  const backendTranslation = code.translate('campaign', campaignCode);

  // If backend returns the same code (no translation found), try activityOptions
  if (backendTranslation === campaignCode) {
    const activity = activityOptions.find(opt => opt.value === campaignCode);
    if (activity) {
      return activity.label;
    }
  }

  return backendTranslation;
};
